// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Events from './pages/Events';

// NEW PAGES
import Association from './pages/Association';
import Board from './pages/Board';
import Partners from './pages/Partners';
import Freshers from './pages/Freshers';
import Harassment from './pages/Harassment';
import Study from './pages/Study';
import Merch from './pages/merch';
import RulesFI from './pages/documents/RulesFI'
import RulesEN from './pages/documents/RulesEN'
import PartnershipOptions from './pages/partners/partnership_options'
import MembershipPrivacyPolicy from './pages/documents/Membership_privacy_policy';
import EventsPrivacyPolicy from './pages/documents/Events_privacy_policy';
import Privacy from './pages/documents/Privacy';
import EqualityPlan from './pages/documents/Equality_plan';
import SaferSpacePrinciples from './pages/documents/Safer_space_principles';
import EnvironmentalPlan from './pages/documents/Environmental_plan';

import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/association" element={<Association />} />
          <Route path="/board" element={<Board />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/events" element={<Events />} />
          <Route path="/freshers" element={<Freshers />} />
          <Route path="/harassment" element={<Harassment />} />
          <Route path="/study" element={<Study />} />,
          <Route path="/merch" element={<Merch />} />
          <Route path="/rulesFI" element={<RulesFI />} />
          <Route path="/rulesEN" element={<RulesEN />} />
          <Route path="/partners/Partnership_Options" element={<PartnershipOptions />} />
          <Route path="/privacy/Membership_privacy_policy" element={<MembershipPrivacyPolicy />} />
          <Route path="/privacy/Events_privacy_policy" element={<EventsPrivacyPolicy/>} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/documents/equality_plan" element={<EqualityPlan />} />
          <Route path="/documents/safer_space_principles" element={<SaferSpacePrinciples />} />
          <Route path="/documents/environmental_plan" element={<EnvironmentalPlan />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;